import styled from 'styled-components';

export const KycModalContainer = styled.div`
    text-align: center;
    border: 1px solid ${props => props.theme.black};

    h3,
    h3:first-child {
        margin: 20px 0;
    }

    h3.banner {
        margin: 0;
        padding: 20px 0;
        background-color: ${props => props.theme.primary};
        color: ${props => props.theme.white};

        &.error {
            background-color: ${props => props.theme.error};
        }
    }

    .body {
        padding: 0 40px 20px;
    }

    p {
        margin-top: 20px;
    }

    .button-wrapper {
        margin: 20px 0 0;
    }

    .ubble {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
    }

    .valid {
        color: ${props => props.theme.success};
    }

    .invalid {
        color: ${props => props.theme.error};
    }

    .italic {
        font-style: italic;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        height: auto;
        max-height: 450px;
        overflow: auto;

        .body {
            padding: 0 20px 20px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycModalStyle.js